import { FolderSelector } from './FolderSelector';

export const SidebarLibraries = () => {
  return (
    <div className="flex justify-between items-center pl-2 relative">
      <p className="text-[13px] font-semibold text-muted-foreground">Library</p>
      <FolderSelector />
      <div className="absolute right-0 top-9 w-2 h-2" id="open-folder" />
    </div>
  );
};
